import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable } from 'react-use-observable';

import { CloseOutlined } from '@ant-design/icons';
import { Tooltip, Button, Spin } from 'antd';

import Truncate from 'components/Truncate';
import { empty } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import type { IChargebackFiles } from 'v2/interfaces/chargeback';
import chargebackService from 'v2/services/chargeback';

interface IProps {
  data: IChargebackFiles;
  invoiceId: number;
  setUpload: () => void;
}

const ChargebackDetailsListItem = ({ data, invoiceId, setUpload }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);

  const [removeFile] = useCallbackObservable(() => {
    setLoading(true);
    return chargebackService.removeChargebackFile(invoiceId, data.id).pipe(
      tap(() => {
        setUpload();
        setShow(false);
        toast.success('Arquivo excluído com sucesso!');
      }),
      catchError(() => {
        toast.error('Falha ao excluir arquivo');
        return empty();
      }),
      finalize(() => setLoading(false))
    );
  }, [invoiceId, data]);

  if (!show) return null;

  return (
    <div className='flex items-center justify-between border-b border-gray-100 px-4 py-3'>
      <Tooltip placement='top' title={`${data.name}.${data.ext}`}>
        <Truncate count={40} final={'...'}>{`${data.name}.${data.ext}`}</Truncate>
      </Tooltip>
      <Button
        type='text'
        shape='circle'
        onClick={removeFile}
        icon={loading ? <Spin size='small' /> : <CloseOutlined />}
      />
    </div>
  );
};

export default ChargebackDetailsListItem;
